import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import PageHero from "../ones/PageHero";
import AboutUsContent from "../ones/AboutUsContent";
import Footer from "../ones/Footer";
import { aboutContent } from "../data/siteContent";
import CallToAction from "../ones/callToAction";

export default function AboutUsLanding() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero 
        title={aboutContent.heroTitle}
        description="AGS is a trusted provider of geospatial and surveying solutions, helping organizations transform spatial data into meaningful insights"
        badge="About AGS"
      />
      <AboutUsContent />
      <CallToAction />
      <Footer />
    </>
  );
}
